import { EventEmitter } from "eventemitter3";

// TODO: 型付け
export const globalEvents = new EventEmitter();
